import { memo, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Divider, Grid2, Typography } from "@mui/material";

import Accordion from "../components/Accordion.js";
import Spinner from "../components/Spinner.js";
import Search from "../components/Search.js";
import { dayjs, isFuzzyMatch, useSnackbar } from "../utils/index.js";
import { getTeamTasksAdmin } from "../api/index.js";

const TeamTasks = () => {
	const { TEAM_ID } = useParams();
	const { error } = useSnackbar();
	const [tasks, setTasks] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [searchFilter, setSearchFilter] = useState("");
	const [displayTasks, setDisplayTasks] = useState([]);

	const fetchTasks = async () => {
		setIsLoading(true);
		const { success: fetchSuccess, tasks: fetchedTasks, message } = await getTeamTasksAdmin(TEAM_ID);
		if (fetchSuccess) {
			setTasks(fetchedTasks);
		} else {
			error(message);
		}

		setIsLoading(false);
	};

	useEffect(() => {
		fetchTasks();
	}, []);

	useEffect(() => {
		const filterTasks = (tasksToFilter) => tasksToFilter.filter((category) => isFuzzyMatch(category.name, searchFilter)
		|| category.subcategories.some((subcategory) => isFuzzyMatch(subcategory.name, searchFilter))
		|| category.subcategories.some((subcategory) => subcategory.tasks.some((task) => isFuzzyMatch(task.title, searchFilter))));
		setDisplayTasks(filterTasks(tasks));
	}, [searchFilter, tasks]);
	
	return (
		<>
			<Spinner open={isLoading} />
			<Grid2 container display="flex" direction="column" justifyContent="center" alignItems="center">
				<Grid2 width="100%" display="flex" justifyContent="flex-end">
					<Search width="500px" value={searchFilter} onChange={(event) => setSearchFilter(event.target.value)} />
				</Grid2>
				{displayTasks.map((category) => (
					<Grid2 key={category?.name} mt={2} width="100%">
						<Accordion
							alwaysExpanded
							title={(
								<Grid2
									container
									width="100%"
									display="flex"
									direction="row"
									alignItems="center"
									justifyContent="flex-start"
								>
									<Typography>{category.name}</Typography>
								</Grid2>
							)}
							content={(
								<Grid2 container width="100%" display="flex" direction="column" alignItems="center" justifyContent="center" spacing={0} color="black">
									{category.subcategories.map((subcategory, ind) => (
										<Grid2 key={subcategory?.name} mt={ind === 0 ? 1 : 2} width="100%">
											<Accordion
												alwaysExpanded
												key={subcategory?.name}
												titleBackground="info"
												title={(
													<Grid2
														container
														width="100%"
														display="flex"
														direction="row"
														alignItems="center"
														justifyContent="flex-start"
													>
														<Typography>{subcategory.name}</Typography>
													</Grid2>
												)}
												subtitle={(
													<Grid2 container display="flex" direction="row" alignItems="center" justifyContent="center" spacing={0}>
														<Grid2 size={{ xs: 4 }}>
															<Typography>{"Title"}</Typography>
														</Grid2>
														<Grid2 size={{ xs: 4 }} textAlign="center">
															<Typography>{"Open"}</Typography>
														</Grid2>
														<Grid2 size={{ xs: 4 }} textAlign="center">
															<Typography>{"Score"}</Typography>
														</Grid2>
													</Grid2>
												)}
												content={(
													<Grid2 container width="100%" display="flex" direction="column" alignItems="center" justifyContent="center" spacing={0} color="black">
														{subcategory.tasks.map((tsk, indx) => (
															<Grid2 key={`comp_${indx}`} flexDirection="column" width="100%">
																{indx !== 0
																&& (
																	<Grid2 key={`divider_${indx}`} my={1} width="100%">
																		<Divider style={{ width: "100%" }} />
																	</Grid2>
																)}
																<Grid2 key={`row_${indx}`} container alignItems="center">
																	<Grid2 size={{ xs: 4 }}>
																		<Typography>{tsk.title}</Typography>
																	</Grid2>
																	<Grid2 size={{ xs: 4 }} textAlign="center">
																		<Typography>{`${dayjs(tsk.openAt).format("DD/MM/YYYY")}-${dayjs(tsk.closeAt).format("DD/MM/YYYY")}`}</Typography>
																	</Grid2>
																	<Grid2 size={{ xs: 4 }} textAlign="center">
																		{tsk?.score ? (Number.isInteger(tsk?.score) ? tsk.score : tsk.score.toFixed(2)) : "-"}
																	</Grid2>
																</Grid2>
															</Grid2>
														))}
													</Grid2>
												)}
											/>
										</Grid2>
									))}
								</Grid2>
							)}
						/>
					</Grid2>
				))}
				{tasks.length === 0 && (
					<Grid2 container direction="column" alignItems="center" justifyContent="center">
						<Typography variant="h5" sx={{ color: "primary.main", p: 1 }}>{"No tasks found!"}</Typography>
					</Grid2>
				)}
			</Grid2>
		</>
	);
};

export default memo(TeamTasks);
